import { bool, func, number, string } from 'prop-types';
import React from 'react';
import NumberFormat from 'react-number-format';
import { Input } from 'reactstrap';

import getDatasetFromProps from '../../utils/get-dataset-from-props';

class CurrencyInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({ floatValue }) {
    const { onChange, overrideEmptyByZero } = this.props;
    const syntheticEvent = {
      target: {
        value: overrideEmptyByZero ? floatValue || 0 : floatValue,
        name: this.props.name,
        type: 'currency',
        dataset: getDatasetFromProps(this.props),
      },
    };
    onChange(syntheticEvent);
  }

  render() {
    const { value, onChange, overrideEmptyByZero, hasPrefix, ...rest } =
      this.props;
    return (
      <NumberFormat
        value={value}
        customInput={Input}
        onValueChange={this.handleChange}
        thousandSeparator=" "
        decimalSeparator="."
        decimalScale={2}
        prefix={hasPrefix ? '€ ' : ''}
        {...rest}
      />
    );
  }
}

CurrencyInput.propTypes = {
  name: string,
  value: number,
  onChange: func,
  overrideEmptyByZero: bool,
  hasPrefix: bool,
};

CurrencyInput.defaultProps = {
  name: '',
  value: undefined,
  onChange: () => {},
  overrideEmptyByZero: true,
  hasPrefix: true,
};

export default CurrencyInput;
